import { ProviderSidebar } from "@/components/layout/ProviderSidebar";
import { ProviderHeader } from "@/components/layout/ProviderHeader";
import { IntakeForm } from "@/components/intake/IntakeForm";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/routes";

export default function ProviderIntakePage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-background">
      <div className="hidden lg:block">
        <ProviderSidebar />
      </div>
      <div className="flex-1 flex flex-col lg:ml-64">
        <ProviderHeader />
        <main className="flex-1 p-4 md:p-6">
          <div className="mb-6">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate(ROUTES.PROVIDER_PATIENTS)}
              className="mb-2"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to My Patients
            </Button>
            <h1 className="font-display text-2xl sm:text-3xl font-bold text-foreground">
              New Patient Intake
            </h1>
            <p className="mt-1 text-muted-foreground">
              Complete the intake form on behalf of a patient
            </p>
          </div>
          <IntakeForm providerMode redirectTo="/provider/patients" />
        </main>
      </div>
    </div>
  );
}
